export default {
    border: "3px solid #3993d4"
}
